<template>
  <div class="email-container">
    <el-form ref="form" :model="form" :rules="rules" v-if="isSuccess == 0">
      <div class="title">重设密码</div>
      <el-form-item prop="firstPwd">
        <el-input
          autocomplete="off"
          type="password"
          v-model="form.firstPwd"
          prefix-icon="el-icon-lock"
          placeholder="密码"
        ></el-input>
      </el-form-item>
      <el-form-item prop="pwd">
        <el-input
          autocomplete="off"
          type="password"
          v-model="form.pwd"
          prefix-icon="el-icon-lock"
          placeholder="确认密码"
        ></el-input>
      </el-form-item>
      <el-form-item class="rember-pwd">
        <el-button type="primary" @click="puzzleValidate" class="submit-btn"
          >提交</el-button
        >
      </el-form-item>
    </el-form>
    <div class="successArea" v-else-if="isSuccess == 1">
        <div class="circle"><i class="el-icon-check"></i></div>
        <div class="login-txt">密码重设成功</div>
    </div>
    <div class="successArea" v-else>
        <div class="circleX"><i class="el-icon-close"></i></div>
        <div class="login-txt">{{errorMsg}}</div>
    </div>
    <div class="regist">
      返回<span
        style="color: #458cff; cursor: pointer"
        @click="$router.push('/')"
        >登录</span
      >
    </div>
  </div>
</template>
<script>
import api from "@/config/api.js";
export default {
  data() {
    return {
      form: {
        pwd: "",
        firstPwd: "",
      },
      errorMsg:'',
      isSuccess:0,
      rules: {
        pwd: [{ required: true, message: "请输入密码", trigger: "blur" }],
        firstPwd: [
          { required: true, message: "请输入密码", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    // 提交
    puzzleValidate() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.form.firstPwd != this.form.pwd) {
            this.$message({
              message: "两次输入的密码不一致！",
              type: "error",
            });
          } else {
            let token = window.location.href.split('=')[1]
               this.$axios
                .fetchPost(
                    api.emailResetPassword + "?token=" + token + '&nowPassword='+this.$utils.md5(this.form.pwd),
                    {}
                )
                .then((res) => {
                    if (res.code === 200) {
                    this.isSuccess = 1
                    } else {
                      this.isSuccess = 2
                      this.errorMsg = res.errorMsg
                      this.$message.error(res.errorMsg || "修改失败");
                    }
                });
          }
        } else {
          return;
        }
      });
    },
  },
};
</script>
<style scoped>
.email-container{
    border:1px solid #ccc;
    border-radius: 6px;
    width:20%;
    padding:20px;
    position: absolute;
    top:50%;
    left:50%;
    transform: translate(-50%,-50%);
}
.email-container .title{
    text-align: center;
    font-weight: 700;
    font-size: 18px;
    padding-bottom:10px;
}
.email-container .submit-btn {
  width: 100%;
  border-radius: 5px;
  border: 0px;
  height: 40px;
  font-weight: bolder;
  letter-spacing: 5px;
}
.email-container .el-input {
  width: 100%;
  margin-bottom: 20px;
  height: 100%;
}
.email-container .regist {
  text-align: center;
}
.successArea {
  height: 200px;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
}

.successArea .circle {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  border: 1px solid #458cff;
  background-color: #458cff;
  margin-bottom: 10px;

  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  font-size: 48px;
  color: #fff;
}
.successArea .circleX {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  border: 1px solid RED;
  background-color: RED;
  margin-bottom: 10px;

  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  font-size: 48px;
  color: #fff;
}
.successArea .login-txt{
  font-size: 18px;
  color: #333;
}
</style>


// WEBPACK FOOTER //
// src/page/emailSend.vue